<template>
    <LayoutPage
            imageName="map-bg.jpg">
            <template v-slot:banner>
                <BannerSmallerWithSearchAndButton
                    :imageName="$t('UI.banners.smallerBannerImage')"
                    :title="$te('smartmapsPage.name') ? $t('smartmapsPage.name') : ''"
                    :description="$te('smartmapsPage.description') ? $t('smartmapsPage.description') : ''"
                />
            </template>

            <template v-slot:content>
                <div class="box">
                    <div class="wrapper"
                        :style="{
                            background: `#1f3c49`, //`url('/css/images/homepage/${$t('smartmapsPage.imageBigSecondaryBanner.imagePreview')}') no-repeat top center #1f3c49`,
                            width: '100%',
                            overflow: 'hidden'
                        }">
                        <div class="mm-section"
                            :style="{
                                minHeight: '72px',
                                padding: '1rem 0',
                                width: '100%',
                                background: 'linear-gradient(270deg, rgba(87, 131, 151, 0) 0%, rgb(48, 121, 138) 100%)',
                                position: 'absolute'
                            }">
                            <div class="mm-section-content d-flex justify-content-center box--center">
                                <span class="headline headline--fifth headline--white mb-0">
                                    {{$t('smartmapsPage.imageBigSecondaryBanner.description')}}
                                </span>
                            </div>
                        </div>
                        <img
                            v-if="$te('smartmapsPage.imageBigSecondaryBanner.responsiveImage')"
                            :src="$t('smartmapsPage.imageBigSecondaryBanner.responsiveImage.src')"
                            :srcset="$t('smartmapsPage.imageBigSecondaryBanner.responsiveImage.srcset')"
                        />

                        <div class="mm-section"
                            :style="{
                                minHeight: '86px',
                                padding: '1rem 0',
                                width: '100%',
                                background: 'linear-gradient(270deg, rgba(87, 131, 151, 0) 0%, rgb(70, 51, 85, 1) 100%)',
                                position: 'absolute',
                                bottom: 0
                            }">
                            <div class="mm-section-content d-flex justify-content-center box--center">
                                <span class="headline headline--third headline--white mb-0">
                                    {{$t('smartmapsPage.imageBigSecondaryBanner.title')}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="mm-section" style="background: linear-gradient(0deg, #203C47 0%, #17292f 100%)">
                        <div class="mm-section-content">
                            <div class="container-fluid mb-5 mt-5 w-100">
                                <SmallIconFeatureList
                                    iconClassName="mm-hp-icon-2x"
                                    itemClassName="col-md-4 col-lg-4 col-sm-6 text--white"
                                    textIconClassName="text--light-grey text--basic-paragraph"
                                    :list="$t('smartmapsPage.featureIconListsA')"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="mm-section box--grey">
                        <div class="mm-section-content">
                            <div class="container-fluid w-100">
                                <div class="row">
                                    <div class="col-12 box box--center box--space-vertical">
                                        <span class="headline headline--fourth pt-5">
                                            {{$t('smartmapsPage.contentHeading')}}
                                        </span>
                                    </div>
                                    <div class="col">
                                        <Themes
                                            containerClassName="row"
                                            itemClassName="col-md-4 col-lg-3 col-sm-6"
                                            v-if="themes"
                                            :themes="themes"
                                            :onThemeClick="onThemeClick"
                                        />
                                        <div v-else class="box box--center box--space-bottom">
                                            <app-spinner />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import LayoutPage from '@/components/layouts/Page';

import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';
import SmallIconFeatureList from '@/components/solutions/smallIconFeatureList';
import Themes from '@/components/ui/Themes';
import { openMapComposition, getThemesPromise } from '@/services/MapsfyApi';

const bbox =  "POLYGON((17.639069403496123 47.732445114360566,20.43508991092021 47.732445114360566,20.43508991092021 49.43469249275006,17.639069403496123 49.43469249275006,17.639069403496123 47.732445114360566))";

export default {
    components: {
        LayoutPage,
        BannerSmallerWithSearchAndButton,
        SmallIconFeatureList,
        Themes
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
        this.loadData(bbox);
    },
    data() {
        return {
            themes: null
        };
    },
    methods: {
        onThemeClick(theme) {
            this.$router.push({name: 'mapApp'});
            openMapComposition(theme.hash);
        },
        loadData(bbox) {
            this.themesRequestState = "request";
            // eslint-disable-next-line
            getThemesPromise('municipality', bbox)
                .then(res => {
                    this.themesRequestState = "success";
                    this.themes = res;
                })
                .fail(() => {
                    this.themesRequestState = "failure";
                });

        }
    }

}
</script>


<style lang="scss" scoped>

.wrapper {
    width: 100%;
    min-height: 758px;
    display: flex;
    position: relative;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    z-index: 2010;
}
</style>
